<script setup lang="ts">
  import { TranslationComponent as translation } from "i18next-vue";
  import { FormLabelKeysEnum } from "../locale/translation-keys/all-keys.js";
  import { TranslationNamespaceEnum } from "../locale/settings/translation-namespaces.js";
  import { useSiteLanguage } from '../composables/use-site-language.js';
  import { useFormServices, useTranslation } from "../composables/use-form-services.js";

  const { FormSettings } = useFormServices({ callerLabel: "privacy-statement.vue" });
  const { localeUrlPrefix } = useSiteLanguage({ callerLabel: "single-complete" });
  var statementKey = (FormSettings.formSettingsKey === "subscription")
    ? FormLabelKeysEnum.privacyNewsletterOptIn
    : FormLabelKeysEnum.privacyStatement;

  const { translate } = useTranslation();
  
</script>

<template>
  <!-- Privacy policy -->
  <div id="privacy-statement" class="privacy-statement">
    <translation :translation="translate(statementKey, { ns: TranslationNamespaceEnum.formLabels })">
      <template #privacy-policy-link-slot>
        <a class="privacy-href" :href="`${localeUrlPrefix}/privacy/`" target="_blank">
          {{ translate(FormLabelKeysEnum.privacyPolicyLinkText, { ns: TranslationNamespaceEnum.formLabels }) }}
        </a>
      </template>
    </translation>
  </div>
</template>